import React, { useState } from 'react';

const customTextColors = [
    '#ADFF2F', '#FFFF00', '#DAA520', '#FFD700', '#FBCEB1',
    '#FFCBA4', '#FDBCB4', '#FFAE42', '#FFA500', '#FF7034',
    '#FE6F5E', '#FF5349', '#800000', '#7F1734', '#FF0000',
    '#E34234', '#D10047', '#FF43A4', '#FF91A4', '#FFA6C9',
    '#FF00FF', '#8B00FF', '#E30B5D', '#70193D', '#C71585',
    '#FF77FF', '#E6E6FA', '#D8BFD8', '#DA70D6', '#9932CC',
    '#800080', '#DDA0DD', '#8A2BE2', '#7851A9', '#8A2BE2',
    '#CCCCFF', '#5F9EA0', '#191970', '#000080', '#4169E1',
    '#0000FF', '#007BA7', '#00FFFF', '#0095B6', '#87CEEB',
    '#40E0D0', '#008080', '#7FFFD4', '#00CED1', '#50C878',
    '#29AB87', '#2E8B57', '#008000', '#228B22', '#01796F',
    '#32CD32', '#ADFF2F', '#00FF7F', '#556B2F', '#804000',
    '#704214', '#A52A2A', '#D2B48C', '#808080', '#000000',
    '#FFFFFF',
];

export default function TemplateColorSwatchPicker({ selectedColor, onSelect }) {
    const [expanded, setExpanded] = useState(false);
    const visibleColors = expanded ? customTextColors : customTextColors.slice(0, 3);
    const [showPopover, setShowPopover] = useState(false);

    return (
        <div>
            <div className="flex flex-wrap gap-2 mb-2">
                {visibleColors.map((color, index) => (
                    <button
                        key={index}
                        title={color}
                        className={`w-6 h-6 rounded-full border-2 ${selectedColor?.toLowerCase() === color.toLowerCase()
                                ? color.toLowerCase() === '#ffffff'
                                    ? 'border-gray-400'
                                    : 'border-black'
                                : 'border-transparent'
                            }`}
                        style={{ backgroundColor: color, boxSizing: 'border-box' }}
                        onClick={() => onSelect(color)}
                    />
                ))}
            </div>

            <div className="relative inline-block">
                <button
                    className="text-sm text-blue-600 hover:underline"
                    onClick={() => setShowPopover(true)}
                >
                    Show more colors
                </button>

                {showPopover && (
                    <div
                        className="absolute z-50 bottom-full mb-2 p-3 bg-white border border-gray-200 rounded shadow-lg w-[180px]"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="grid grid-cols-5 gap-2">
                            {customTextColors.map((color, index) => (
                                <button
                                    key={index}
                                    title={color}
                                    className="w-6 h-6 rounded-full border-2"
                                    style={{
                                        backgroundColor: color,
                                        borderColor:
                                            selectedColor?.toLowerCase() === color.toLowerCase()
                                                ? color.toLowerCase() === '#ffffff'
                                                    ? '#a3a3a3'
                                                    : '#000000'
                                                : 'transparent',
                                        boxSizing: 'border-box',
                                    }}
                                    onClick={() => {
                                        onSelect(color);
                                        setShowPopover(false);
                                    }}
                                />
                            ))}
                        </div>

                        <button
                            className="mt-2 text-xs text-gray-600 hover:underline"
                            onClick={() => setShowPopover(false)}
                        >
                            × Close
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}
